// extracted by mini-css-extract-plugin
export var menuItem = "y_tJ d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "y_tK d_Z d_bz d_bP";
export var menuMainLink = "y_tL d_f0 d_dB";
export var menuLink = "y_tM d_f0 d_dB";
export var icon = "y_p9 d_bC d_bP";
export var divider = "y_tN d_bC d_bP";
export var sublinks = "y_tP";
export var link = "y_mC";
export var Link = "y_sv t_sv t_rT t_sc";